var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { ExclamationCircleIcon } from '../icons/index.js';
import { useInputColors } from '../utils/styles/index.js';
export const Textarea = forwardRef((_a, ref) => {
    var { invalid = false, hidden, className, disabled } = _a, rest = __rest(_a, ["invalid", "hidden", "className", "disabled"]);
    const { inputClsx } = useInputColors({
        invalid,
        disabled,
    });
    return (React.createElement("div", { className: clsx('flex relative rounded-md shadow-sm', hidden && 'hidden') },
        React.createElement("textarea", Object.assign({ ref: ref, className: clsx(' block w-full rounded-md', inputClsx, invalid && 'pe-10', className), rows: 4, disabled: disabled, hidden: hidden }, rest)),
        invalid && (React.createElement("div", { className: "absolute top-0 end-0 pe-3 pt-3 flex items-center pointer-events-none" },
            React.createElement(ExclamationCircleIcon, { className: "h-5 w-5 text-action-destructive", "aria-hidden": "true" })))));
});
//# sourceMappingURL=Textarea.js.map